import { BoomGateOutlineIcon } from './BoomGateOutlineIcon';

/**
 * author: Michael Richins
 * id EF1F53B3-DA99-4410-9A20-E12C42FC2461
 * name boom-gate-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/boom-gate-outline.svg
 * tags
 * - Transportation + Road 
 * - Home Automation 
 */
export const ArmBarrierOutlineIcon = BoomGateOutlineIcon;
export default ArmBarrierOutlineIcon